import ModalFooter from './customModal/modalFooter';
import {useState} from 'react';
import {toast} from 'react-toastify';
import api from '../Interceptor';
import {getRoute} from '../api/routes';
import {useNavigate} from 'react-router-dom';

const DeleteAccount = ({onClose}) => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleConfirm = async () => {
    try {
      setIsLoading(true);
      const response = await api.patch(
        getRoute('users', 'admin', 'initializeDelete', false),
        {
          adminId: localStorage.getItem('id'),
          statusId: process.env.REACT_APP_STATUS_INACTIVE,
        }
      );

      if (response.status === 200) {
        toast.success('Account deletion initialize successfully!');
        localStorage.clear();
        navigate('/');
      }
    } catch (error) {
      toast.error('Failed to update status.');
      console.error('Error updating status:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <div className="bg-red-100 p-6 rounded-xl shadow-lg text-center border border-red-400 text-red-700">
        <h2 className="text-xl font-semibold mb-2">Account Deletion Warning</h2>
        <p className="text-gray-700 mb-4">
          If you don’t log in again within <strong>29 days</strong>, your
          account will be
          <span className="font-semibold text-red-600">
            {' '}
            permanently deleted
          </span>{' '}
          along with all your data.
        </p>
        <p className="text-gray-600">
          To recover your account, simply log in again within 29 days.
        </p>
      </div>

      <ModalFooter
        onCancel={onClose}
        isLoading={isLoading}
        onSave={handleConfirm}
      />
    </div>
  );
};

export default DeleteAccount;
